// extracted by mini-css-extract-plugin
export var inner = "index-module--inner--bAcpq";
export var partnerRights = "index-module--partnerRights--eDYmB";
export var partnerRightsContent = "index-module--partnerRightsContent--LbSdB";